export const AI_TERMS_OF_USE_URL = 'https://iterable.com/trust/additional-ai-terms-of-use/';
